import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SubSideNavItemPrefixProps = ComponentPropsWithoutRef<'span'>;

export const SubSideNavItemPrefix = memo(({ className, ...restOfProps }: SubSideNavItemPrefixProps) => {
  return <span className={cn('flex size-5 shrink-0 items-center justify-center', className)} {...restOfProps} />;
});

SubSideNavItemPrefix.displayName = 'SubSideNavItemPrefix';
